import { render, staticRenderFns } from "./projectManagement.vue?vue&type=template&id=588520e4&scoped=true&"
import script from "./projectManagement.vue?vue&type=script&lang=js&"
export * from "./projectManagement.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=588520e4&prod&lang=scss&scoped=true&"
import style1 from "./projectManagement.vue?vue&type=style&index=1&id=588520e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588520e4",
  null
  
)

export default component.exports